export enum RecipeType {
  Meat = 'meat',
  Poultry = 'poultry',
}
